module.exports = __webpack_public_path__ + "static/img/gaozhongyuwen.8157c73f.jpg";